import { clearStudyDemoDrafts } from './lifecycle';
import type { QueryClient } from '@tanstack/react-query';
import { setDemoApiAdapter } from '@/lib/api';
import { isLocalStudyExperience, EXPERIENCE_KID_ID } from './mode';
import { STUDY_DEMO_LEARNER } from './exampleData';
import { createStudyExperienceAdapter } from './studyExperienceAdapter';

/** Own QueryClient and local data for this document. Existing auth tokens and cookies are untouched. */
export function installStudyStudentExperience(client: QueryClient): boolean {
  if (!isLocalStudyExperience()) return false;
  clearStudyDemoDrafts();
  const year = Number(new URLSearchParams(window.location.search).get('year')) || 8;
  setDemoApiAdapter(createStudyExperienceAdapter(year));
  const learner = {
    kind: 'kid',
    sub: EXPERIENCE_KID_ID,
    nickname: STUDY_DEMO_LEARNER.name,
    age: STUDY_DEMO_LEARNER.age,
    avatar_id: null,
    family_id: null,
    is_ephemeral: false,
    account_mode: 'managed',
    family_kind: null,
    login_email: null,
    has_password: false,
  };
  for (const kind of ['kid', 'user']) client.setQueryData(['auth', 'me', kind], learner);
  return true;
}
